// extracted by mini-css-extract-plugin
module.exports = {"privacy":"Privacy_privacy__2Mfp8","downloadButtons":"Privacy_downloadButtons__drbc3","navBar":"Privacy_navBar__g8wHL"};